import { Typography as AntTypography, TypographyProps } from "antd";
import styled from "styled-components";

export const Typography: typeof AntTypography = styled(
  AntTypography
)<TypographyProps>``;
